import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f5f93ea2")

_pushScopeId("data-v-f5f93ea2")
const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = { class: "card-body h-100" }
const _hoisted_3 = { class: "row h-100" }
const _hoisted_4 = { class: "calendar" }
const _hoisted_5 = { class: "btn-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "btn btn-primary"
}
const _hoisted_7 = { class: "content" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "date-title" }, [
  /*#__PURE__*/_createVNode("div", null, "일"),
  /*#__PURE__*/_createVNode("div", null, "월"),
  /*#__PURE__*/_createVNode("div", null, "화"),
  /*#__PURE__*/_createVNode("div", null, "수"),
  /*#__PURE__*/_createVNode("div", null, "목"),
  /*#__PURE__*/_createVNode("div", null, "금"),
  /*#__PURE__*/_createVNode("div", null, "토")
], -1)
const _hoisted_9 = { class: "date-wrapper" }
const _hoisted_10 = { class: "day-desc" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = { class: "modal-wrapper" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h3", null, " 파트너스 검색 ")
], -1)
const _hoisted_15 = { class: "modal-content" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_17 = { class: "input-wrapper mb-3" }
const _hoisted_18 = { class: "partners-search-wrapper" }
const _hoisted_19 = { class: "table table-responsive-sm table-bordered table-striped table-sm" }
const _hoisted_20 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("th", { class: "text-center" }, "서브몰 ID"),
  /*#__PURE__*/_createVNode("th", { class: "text-center" }, "파트너스명")
], -1)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createVNode("td", {
  colspan: "2",
  class: "text-center"
}, "검색된 결과가 없습니다.", -1)
_popScopeId()

import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ApiService } from '@/services/backend-api/api.services';
import calendar from '@/helper/calendar.util';
import { useStore } from 'vuex';
import { key } from '@/store';
import swal from '@/helper/swal.helper';
import commerceUtil from '@/helper/commerceUtil';


export default _defineComponent({
  expose: [],
  setup(__props) {

const apiService = new ApiService();
const router = useRouter();
const store = useStore(key);
const today = calendar.getToday();
const currentYear = ref(today.$y);
const currentMonth = ref(today.$M);
const currentDate = ref(today);
const monthData = ref([]);
const type = ref('');
const isShowSearch = ref(false);
const partnerName = ref('');
const partnerList = ref([]);
const selectedPartnerName = ref('');
const selectedPartnerId = ref(0);

monthData.value = calendar.getMonthData(currentYear.value, currentMonth.value);
const scheduleList = ref([]);
onMounted(() => {
  getSchedule();
});
const prevMonth = () => {
  currentMonth.value -= 1;
  setCalendar();
};
const nextMonth = () => {
  currentMonth.value += 1;
  setCalendar();
};
const moveToday = () => {
  currentYear.value = today.$y;
  currentMonth.value = today.$M;
  setCalendar();
};
const setCalendar = () => {
  monthData.value = calendar.getMonthData(
    currentYear.value,
    currentMonth.value,
  );
  currentDate.value = calendar.getDate(
    currentYear.value,
    currentMonth.value,
    1,
  );
  getSchedule();
};
const getSchedule = async () => {
  store.commit('loading/showLoading', '데이터를 불러오는 중입니다.');
  let params = {};
  if (selectedPartnerId.value) {
    params = {
      start_date: `${currentDate.value.format(
        'YYYY',
      )}-${currentDate.value.format('MM')}-01`,
      end_date: calendar.getMonthLastday(
        currentYear.value,
        currentMonth.value + 1,
      ),
      partners_data_id: selectedPartnerId.value,
    };
  } else {
    params = {
      start_date: `${currentDate.value.format(
        'YYYY',
      )}-${currentDate.value.format('MM')}-01`,
      end_date: calendar.getMonthLastday(
        currentYear.value,
        currentMonth.value + 1,
      ),
    };
  }
  const response = await apiService.get('/v2/booking/provision/period', params);
  if (!response.status) {
    swal.alert(response.message);
  }
  scheduleList.value = response.data.items;
  setCalendarData();
  store.commit('loading/hideLoading');
};
const setCalendarData = () => {
  calendar.getHoliday();
  monthData.value.forEach((week: []) => {
    week.forEach((date: object) => {
      const data = scheduleList.value.find(
        item =>
          item.fishing_date.split('.').join('-') === date.format('YYYY-MM-DD'),
      );
      date.scheduleData = data;
    });
  });
};
const goSchedule = (date: object) => {
  if (selectedPartnerId.value) {
    router.push(
      `/partners/booking-schedule/${selectedPartnerId.value}?date=${date
        .split('.')
        .join('-')}`,
    );
  } else {
    router.push(`/partners/booking-schedule?date=${date.split('.').join('-')}`);
  }
};
const openSearchModal = () => {
  isShowSearch.value = true;
};
const closeSearchModal = () => {
  partnerName.value = '';
  partnerList.value = [];
  isShowSearch.value = false;
};
const searchPartners = async () => {
  if (partnerName.value === '') {
    swal.alert('파트너 이름이 입력되지 않았습니다.');
    return false;
  }
  try {
    const response = await apiService.get(
      '/v2/booking/provision/search/partners',
      {
        page: 0,
        size: 200,
        partners_profile_nm: partnerName.value,
      },
    );
    if (response.data.items.length === 0) {
      swal.alert('검색 결과가 없습니다');
      partnerName.value = '';
      partnerList.value = [];
      return false;
    }
    partnerList.value = response.data.items;
  } catch {
    swal.alert('오류가 발생했습니다');
    partnerName.value = '';
    partnerList.value = [];
  }
};
const selectPartner = async (partner: any) => {
  closeSearchModal();
  selectedPartnerName.value = partner.partners_profile_nm;
  selectedPartnerId.value = partner.partners_data_id;
  getSchedule();
};
const resetPartner = () => {
  selectedPartnerName.value = '';
  selectedPartnerId.value = 0;
  getSchedule();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("header", null, [
            _createVNode("div", _hoisted_5, [
              _createVNode("button", {
                class: "btn btn-primary mr-3",
                onClick: prevMonth
              }, " 이전달 "),
              _createVNode("h3", null, _toDisplayString(currentDate.value.$y) + "년 " + _toDisplayString(currentDate.value.$M + 1) + "월", 1),
              _createVNode("button", {
                class: "btn btn-primary ml-3 mr-3",
                onClick: nextMonth
              }, " 다음달 "),
              _createVNode("button", {
                onClick: moveToday,
                class: "btn btn-primary mr-3"
              }, " 오늘 "),
              (selectedPartnerId.value)
                ? (_openBlock(), _createBlock("button", _hoisted_6, _toDisplayString(selectedPartnerName.value), 1))
                : _createCommentVNode("", true),
              (selectedPartnerId.value)
                ? (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: "btn btn-default",
                    onClick: resetPartner
                  }, " 리셋 "))
                : (_openBlock(), _createBlock("button", {
                    key: 2,
                    onClick: openSearchModal,
                    class: "btn btn-primary"
                  }, " 파트너스 검색 "))
            ])
          ]),
          _createVNode("section", _hoisted_7, [
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(monthData.value, (week, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: "week",
                  key: 'key' + index
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(week, (day) => {
                    return (_openBlock(), _createBlock("div", {
                      class: ["date", {
                    'not-this-month': day.$M !== currentDate.value.$M,
                    today: day.$M === _unref(today).$M && day.$D === _unref(today).$D,
                  }],
                      onClick: ($event: any) => (goSchedule(day.scheduleData?.fishing_date)),
                      key: day.scheduleData?.fishing_date
                    }, [
                      _createVNode("h4", {
                        class: ["day", {
                      holiday: day.holiday?.isHoliday,
                      underline: day.scheduleData?.provision_price > 0,
                    }]
                      }, [
                        _createTextVNode(_toDisplayString(day.$D) + " ", 1),
                        _createVNode("span", _hoisted_10, _toDisplayString(day.holiday?.isHoliday ? day.holiday.desc : ''), 1)
                      ], 2),
                      (day.$M === currentDate.value.$M)
                        ? (_openBlock(), _createBlock("div", _hoisted_11, [
                            (
                        day.scheduleData?.provision_summary_status &&
                          day.scheduleData?.provision_summary_status !==
                            'UNDETERMINED_SALES'
                      )
                              ? (_openBlock(), _createBlock("p", {
                                  key: 0,
                                  class: {
                        complete:
                          day.scheduleData?.provision_summary_status ===
                          'CONFIRM_SALES_AND_COMPLETE_PROVISION',
                      }
                                }, _toDisplayString(_unref(commerceUtil).getCurrency(day.scheduleData?.sales_price)) + "원 매출 ", 3))
                              : _createCommentVNode("", true),
                            (
                        day.scheduleData?.provision_summary_status?.includes(
                          'CONFIRM_SALES',
                        ) && day.scheduleData?.provisioned_price
                      )
                              ? (_openBlock(), _createBlock("p", {
                                  key: 1,
                                  class: {
                        complete:
                          day.scheduleData?.provision_summary_status ===
                          'CONFIRM_SALES_AND_COMPLETE_PROVISION',
                      }
                                }, [
                                  _createTextVNode(_toDisplayString(day.scheduleData?.provision_date) + " 지급 ", 1),
                                  _hoisted_12,
                                  _createTextVNode(" " + _toDisplayString(_unref(commerceUtil).getCurrency(
                          day.scheduleData?.provisioned_price,
                        )) + "원 ", 1)
                                ], 2))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ], 10, ["onClick"]))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", {
      class: ["admin-modal", { 'show-modal': isShowSearch.value }]
    }, [
      _createVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode("div", _hoisted_17, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (partnerName.value = $event)),
              type: "text",
              class: "form-control mr-3",
              onKeyup: _withKeys(searchPartners, ["enter"])
            }, null, 40, ["onKeyup"]), [
              [_vModelText, partnerName.value]
            ]),
            _createVNode("button", {
              class: "btn btn-primary",
              onClick: searchPartners
            }, " 검색 ")
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("table", _hoisted_19, [
              _hoisted_20,
              (partnerList.value.length > 0)
                ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(partnerList.value, (partner) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: partner.toss_sub_mall_id,
                      onClick: ($event: any) => (selectPartner(partner))
                    }, [
                      _createVNode("td", null, _toDisplayString(partner.toss_sub_mall_id), 1),
                      _createVNode("td", null, _toDisplayString(partner.partners_profile_nm), 1)
                    ], 8, ["onClick"]))
                  }), 128))
                : (_openBlock(), _createBlock("tr", _hoisted_21, [
                    _hoisted_22
                  ]))
            ])
          ]),
          _createVNode("div", { class: "btn-box" }, [
            _createVNode("button", {
              class: "btn btn-danger",
              onClick: closeSearchModal
            }, " 닫기 ")
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})